import { createSlice } from "@reduxjs/toolkit";

const affiliateSlice = createSlice({
  name: "affiliate",
  initialState: {
    affiliateInfo: [],
    affiliateManagement: {},
    affiliateProductivity: {},
    affiliateTransactions: [],
    affiliateAllPrivileges: [],
    buttonBeAffiliatedMenu: false,
    isAffiliate: [],
  },
  reducers: {
    setIsAffiliate(state, { payload }) {
      state.isAffiliate = payload;
    },
    setAffiliateInfo(state, { payload }) {
      state.affiliateInfo = payload;
    },
    setAffiliateManagement(state, { payload }) {
      state.affiliateManagement = payload;
    },
    setButtonBeAffiliatedMenu(state, { payload }) {
      state.buttonBeAffiliatedMenu = payload;
    },
    setAffiliateProductivity(state, { payload }) {
      state.affiliateProductivity = payload;
    },
    setAffiliateTransactions(state, { payload }) {
      state.affiliateTransactions = payload;
    },
    setAffiliateAllPrivileges(state, { payload }) {
      state.affiliateAllPrivileges = payload;
    },
  },
});

export const {
  setIsAffiliate,
  setAffiliateInfo,
  setAffiliateManagement,
  setAffiliateProductivity,
  setAffiliateTransactions,
  setButtonBeAffiliatedMenu,
  setAffiliateAllPrivileges,
} = affiliateSlice.actions;

export default affiliateSlice.reducer;
